import React, { } from "react";
import "./Service_pages.scss";
import img from "./services/preventive_dentistry.png"; // Replace with your actual image path
import img2 from "./services/dental.png";
import { FaCheckCircle, FaTooth, FaMicroscope, FaSmile, FaThumbsUp, FaUserMd, FaHeart, FaShieldAlt, FaClinicMedical, FaCamera, FaSearch } from 'react-icons/fa';
import { MdOutlineHealthAndSafety, MdOutlineVisibility } from "react-icons/md";
import { GiToothbrush } from "react-icons/gi";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const PreventiveDentistry = () => {

    const types = [
        {
            title: "Fluoride Treatments",
            icon: <MdOutlineHealthAndSafety />,
            desc: "Strengthens tooth enamel and makes it more resistant to acid attacks from bacteria. Highly beneficial for children with developing teeth and adults with weakened enamel to prevent decay.",
        },
        {
            title: "Dental Sealants",
            icon: <FaShieldAlt />,
            desc: "Protective coatings applied to the chewing surfaces of molars and premolars. They create a barrier in deep grooves, preventing food particles and bacteria from causing cavities.",
        },
        {
            title: "Professional Cleaning",
            icon: <FaTooth />,
            desc: "Removes stubborn plaque and tartar buildup that regular brushing misses. This essential service reduces gum disease risk, prevents decay, and keeps your breath fresh.",
        },
        {
            title: "Diagnostic Imaging",
            icon: <FaMicroscope />,
            desc: "We use digital X-rays and diagnostic imaging to detect hidden problems like bone loss, impacted teeth, or decay between teeth that aren't visible during a routine exam.",
        },
    ];

    const disadvantages = [
        {
            title: "Regular Time Commitment",
            description: "Requires consistent 6-month visits to be effective, which may be challenging for busy schedules but prevents emergency surgeries.",
        },
        {
            title: "Dependency on Home Care",
            description: "Professional prevention is a partnership; it requires strict adherence to daily flossing and brushing habits at home to be successful.",
        },
        {
            title: "Cost of Advanced Scans",
            description: "While routine exams are affordable, specialized imaging like CBCT for detailed evaluation may incur additional diagnostic costs.",
        },
        {
            title: "Temporary Sensitivity",
            description: "Patients with existing gum inflammation or heavy tartar may experience mild, temporary sensitivity after a deep professional cleaning.",
        },
        {
            title: "Maintenance of Sealants",
            description: "Dental sealants are durable but may require re-evaluation or minor repair over several years to ensure the barrier remains intact.",
        },
    ];

    const benefits = [
        {
            category: "Disease Prevention",
            benefit: "Reduces Cavities & Gum Disease",
            description: "Proactive removal of plaque and tartar prevents the primary causes of tooth decay and gingivitis.",
        },
        {
            category: "Disease Prevention",
            benefit: "Preserves Natural Teeth",
            description: "Early intervention allows patients to keep their original teeth for a lifetime, avoiding extractions.",
        },
        {
            category: "Overall Health",
            benefit: "Reduces Systemic Health Risks",
            description: "Maintaining oral health is linked to a lower risk of heart disease, diabetes, and respiratory infections.",
        },
        {
            category: "Overall Health",
            benefit: "Fresh Breath & Bright Smile",
            description: "Removes the bacteria and surface stains that cause persistent bad breath and yellowing of the teeth.",
        },
        {
            category: "Early Detection",
            benefit: "Identifies Issues Early",
            description: "Detects tooth decay, bite problems, and oral infections at a stage where treatment is simple and less invasive.",
        },
        {
            category: "Early Detection",
            benefit: "Oral Cancer Screening",
            description: "Routine checkups at Kosmix include monitoring of oral tissues to detect early signs of oral health issues.",
        },
        {
            category: "Financial",
            benefit: "Cost-Effective Care",
            description: "Saves significant money in the long run by avoiding complex procedures like root canals or dental implants.",
        },
    ];

    const reasons = [
        {
            icon: <FaUserMd />,
            title: 'Experienced Professionals',
            description: 'Our team focuses on early detection and patient education to help you maintain a healthy smile for life.'
        },
        {
            icon: <MdOutlineVisibility />,
            title: 'Advanced Technology',
            description: 'We utilize Digital X-rays, CBCT imaging, and high-powered magnification for precise diagnostic accuracy.'
        },
        {
            icon: <FaHeart />,
            title: 'Comprehensive Services',
            description: 'From routine scaling to advanced fluoride applications and pediatric sealants, we cover all family age groups.'
        },
        {
            icon: <FaThumbsUp />,
            title: 'Personalized Care',
            description: 'Every patient receives a customized preventive plan tailored to their specific oral health risks and lifestyle.'
        },
        {
            icon: <FaShieldAlt />,
            title: 'Focus on Education',
            description: 'We empower patients with the right brushing and flossing techniques to maintain their health at home.'
        },
        {
            icon: <FaClinicMedical />,
            title: 'Hygienic Environment',
            description: 'A clean, sterilized, and comfortable clinic environment ensuring total safety for your entire family.'
        }
    ];

    return (
        <>
            <div className="service1-section">
                <Helmet>
                    <title>Preventive Dentistry in HSR Layout | Routine Dental Checkup Bengaluru</title>
                    <meta
                        name="description"
                        content="Maintain oral health with Preventive Dentistry in HSR Layout. Kosmix Dental Clinic offers routine checkups, fluoride, and sealants to prevent cavities."
                    />
                    <link
                        rel="canonical"
                        href="https://www.kosmixdentalclinic.com/services/preventive-dentistry-in-hsr-layout"
                    />
                </Helmet>

                <div className="hero">
                    <h1 className="service1-title-text" data-aos="fade-down" data-aos-delay="200">
                        Preventive Dentistry in HSR Layout, Bengaluru
                    </h1>

                    <div className="hero-content">
                        <div className="hero-image" data-aos="zoom-in-right" data-aos-delay="200" data-aos-duration="800">
                            <img src={img} alt="Preventive Dental Care at Kosmix" />
                        </div>

                        <div className="hero-text" data-aos="zoom-in-left" data-aos-delay="200" data-aos-duration="800">
                            <p>
                                Maintaining healthy teeth and gums requires more than treating dental problems after they occur.
                                <strong> Preventive dentistry</strong> focuses on protecting your oral health before issues develop.
                                Through regular dental checkups, professional cleanings, and early diagnosis, we help reduce the risk
                                of cavities and gum disease.
                            </p>
                            <p>
                                At Kosmix Dental Clinic in HSR Layout, Bengaluru, preventive dentistry is an essential part of
                                our comprehensive dental care approach. Our experienced dental team focuses on early detection,
                                patient education, and advanced preventive treatments that help maintain strong teeth.
                            </p>
                            <p>
                                Preventive dental care allows patients to preserve their natural teeth for a lifetime. By identifying
                                potential dental problems early, we reduce the need for complex and costly dental procedures in the future.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="content" data-aos="fade-up" data-aos-delay="300" >
                    <SectionTitle title="What is Preventive Dentistry?" />
                    <div className="text_first" >
                        <p1>
                            Preventive dentistry refers to dental care practices and treatments designed to maintain oral health and prevent dental diseases before they develop. It includes professional dental treatments—like routine checkups, cleanings, and diagnostic imaging—and daily oral hygiene habits that help protect teeth and gums.
                        </p1>
                    </div>
                </div>

                <div className="compare-section">
                    <div className="compare-card crown-card" data-aos="fade-up" data-aos-delay="600">
                        <h3>Care for Children</h3>
                        <h6>
                            Children are more vulnerable to cavities due to developing teeth and dietary habits. Early visits help reduce dental anxiety.
                        </h6>
                        <ul>
                            <li>Regular dental examinations to monitor development.</li>
                            <li>Fluoride applications to strengthen young enamel.</li>
                            <li>Dental sealants for molars and premolars.</li>
                            <li>Oral hygiene education tailored for kids.</li>
                            <li>Monitoring tooth alignment and jaw development.</li>
                        </ul>
                    </div>

                    <div className="compare-card bridge-card" data-aos="fade-up" data-aos-delay="600">
                        <h3>Care for Adults</h3>
                        <h6>
                            As people age, they may experience enamel wear and gum issues. Consistent preventive care is equally important for adults.
                        </h6>
                        <ul>
                            <li>Prevention of gum disease and inflammation.</li>
                            <li>Early detection of tooth decay and enamel wear.</li>
                            <li>Maintenance of existing dental restorations.</li>
                            <li>Protection of overall oral and systemic health.</li>
                            <li>Oral cancer screenings and tissue checks.</li>
                        </ul>
                    </div>
                </div>

                <section className="importance-section">
                    <div className="content">
                        <SectionTitle title="Importance of Preventive Care" />
                        <p1 className="text_first" data-aos="fade-up" data-aos-delay="100">
                            Oral health is closely connected to overall health. Poor oral hygiene and untreated gum disease have been
                            linked to heart disease, diabetes, and respiratory infections.
                        </p1>
                    </div>

                    <div className="importance-grid-premium">
                        {[
                            { title: "Early Detection", icon: <FaMicroscope />, desc: "Monitors tooth decay, gum disease, and bite problems before they worsen." },
                            { title: "Tooth Preservation", icon: <FaTooth />, desc: "Allows patients to keep their original teeth and avoid extractions." },
                            { title: "Reduced Complexity", icon: <FaThumbsUp />, desc: "Treating issues early makes procedures simpler, less invasive, and more cost-effective." },
                            { title: "Gum Health Protection", icon: <FaShieldAlt />, desc: "Removes plaque and tartar to prevent gingivitis and periodontitis." },
                            { title: "Fresh Breath", icon: <FaSmile />, desc: "Professional cleaning removes bacteria and plaque that cause halitosis." },
                        ].map((item, index) => (
                            <div className="premium-feature-card" data-aos="fade-up" data-aos-delay={150 + index * 100} key={index}>
                                <div className="feature-icon-wrapper">
                                    {item.icon}
                                </div>
                                <div className="feature-content">
                                    <div className="feature-number">0{index + 1}</div>
                                    <h4>{item.title}</h4>
                                    <p>{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="why-choose-us">
                    <div className="wrapper">
                        <div className="image-side" data-aos="zoom-in" data-aos-delay="100">
                            <img src={img2} alt="Modern Clinic Facility" />
                        </div>

                        <div className="text-side" data-aos="fade-up" data-aos-delay="300">
                            <h2>Modern Technology in Prevention</h2>
                            <p style={{ color: 'black' }}>
                                At <strong>Kosmix Dental Clinic</strong>, we use advanced technology to ensure precise diagnosis and more effective preventive treatments.
                            </p>

                            <div className="advanced-tools-list" data-aos="fade-up" data-aos-delay="400">
                                <h3 className="tools-heading">Our Advanced Tools</h3>
                                <div className="tool-item">
                                    <div className="tool-icon">
                                        <FaCamera />
                                    </div>
                                    <div className="tool-details">
                                        <h4>Digital X-rays & CBCT</h4>
                                        <p>High-resolution imaging for detailed evaluation of bone and hidden decay.</p>
                                    </div>
                                </div>
                                <div className="tool-item">
                                    <div className="tool-icon">
                                        <FaSearch />
                                    </div>
                                    <div className="tool-details">
                                        <h4>Dental Scanners</h4>
                                        <p>Advanced diagnostic scanners for precise evaluation of the dental arch.</p>
                                    </div>
                                </div>
                            </div>

                            <p style={{ color: 'black' }}>
                                These high-powered magnification tools enable our dentists to provide accurate diagnosis and personalized preventive care with minimal discomfort.
                            </p>
                            <p style={{ color: 'black' }}>
                                Regular dental visits allow us to monitor your oral health foundation and ensure your smile stays strong.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="crown-types-section">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Key Preventive Services" />
                        <p1 className="text_first">
                            Our clinic provides comprehensive preventive services designed to protect your oral health and maintain a healthy smile.
                        </p1>
                    </div>

                    <div className="preventive-services-list">
                        {types.map((item, idx) => (
                            <div className="preventive-service-row" key={idx} data-aos="fade-up" data-aos-delay={idx * 150}>
                                <div className="ps-number">0{idx + 1}</div>
                                <div className="ps-icon">{item.icon}</div>
                                <div className="ps-content">
                                    <h3>{item.title}</h3>
                                    <p>{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="timeline-container">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Daily Oral Hygiene for Prevention" />
                        <p className="text_first">
                            Preventive dentistry is most effective when professional care is combined with good habits at home:
                        </p>
                    </div>

                    <div className="timeline-step" data-aos="fade-right">
                        <div className="timeline-icon"><GiToothbrush /></div>
                        <div className="timeline-content">
                            <h3>Brush Twice Daily</h3>
                            <p>Use a fluoride toothpaste and a soft-bristled brush to remove plaque from all tooth surfaces.</p>
                        </div>
                        <div className="timeline-icon">1</div>
                    </div>

                    <div className="timeline-step" data-aos="fade-left">
                        <div className="timeline-icon">🧵</div>
                        <div className="timeline-content">
                            <h3>Regular Flossing</h3>
                            <p>Floss daily to remove plaque and food particles from between teeth where a brush can't reach.</p>
                        </div>
                        <div className="timeline-icon">2</div>
                    </div>

                    <div className="timeline-step" data-aos="fade-right">
                        <div className="timeline-icon">🍎</div>
                        <div className="timeline-content">
                            <h3>Balanced Diet</h3>
                            <p>Limit sugary foods and beverages; maintain a nutritious diet to support your enamel health.</p>
                        </div>
                        <div className="timeline-icon">3</div>
                    </div>

                    <div className="timeline-step" data-aos="fade-left">
                        <div className="timeline-icon">💧</div>
                        <div className="timeline-content">
                            <h3>Hydration</h3>
                            <p>Drink plenty of water throughout the day to support saliva production and rinse away acids.</p>
                        </div>
                        <div className="timeline-icon">4</div>
                    </div>

                    <div className="timeline-step" data-aos="fade-right">
                        <div className="timeline-icon">🗓️</div>
                        <div className="timeline-content">
                            <h3>Bi-Annual Visits</h3>
                            <p>Visit the dentist every six months for routine checkups and professional cleaning.</p>
                        </div>
                        <div className="timeline-icon">5</div>
                    </div>
                </section>

                <section className="advantages-section">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Potential Considerations" />
                        <p1 className="text_first">
                            While preventive dentistry is the gold standard, it is important to be aware of the following factors:
                        </p1>
                    </div>

                    <ul className="considerations-list">
                        {disadvantages.map((item, index) => (
                            <li key={index} className="consideration-bullet" data-aos="fade-up" data-aos-delay={index * 100}>
                                <FaCheckCircle className="consideration-icon" />
                                <div className="bullet-content">
                                    <strong>{item.title}</strong>
                                    <p>{item.description}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </section>

                <section className="benefits-section" data-aos="fade-up">
                    <div className="benefits-wrapper">
                        <div className="content">
                            <h2 className="section-title">Comprehensive Analysis of Preventive Benefits</h2>
                        </div>
                        <div className="table-responsive">
                            <table className="styled-table">
                                <thead>
                                    <tr>
                                        <th>Advantage Category</th>
                                        <th>Specific Benefit</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {benefits.map((item, index) => (
                                        <tr key={index}>
                                            <td className="category-cell">
                                                {index === 0 || item.category !== benefits[index - 1].category ? item.category : ""}
                                            </td>
                                            <td>{item.benefit}</td>
                                            <td>{item.description}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>

                <section className="pricing-section" data-aos="fade-up">
                    <div className="pricing-content-centered">
                        <div className="content" data-aos="fade-up">
                            <SectionTitle title="Prevention FAQs" />
                            <p>
                                <strong>How often should I visit?</strong> Most recommend visiting every six months for routine checkups and cleaning.
                            </p>
                            <p>
                                <strong>Can it stop cavities?</strong> Yes, it significantly reduces risk through professional cleaning, fluoride, and education.
                            </p>
                            <p>
                                <strong>Is it expensive?</strong> Preventive care is generally affordable and helps avoid very costly treatments later by preventing problems.
                            </p>
                        </div>

                        <div className="premium-highlights">
                            <div className="highlight-block">
                                <span className="highlight-badge">Checkups</span>
                                <h3 className="highlight-title">Affordable</h3>
                                <p className="highlight-desc">Essential bi-annual maintenance</p>
                                <ul className="highlight-list">
                                    <li><FaCheckCircle className="check-icon" /> Full Oral Exam</li>
                                    <li><FaCheckCircle className="check-icon" /> Professional Cleaning</li>
                                    <li><FaCheckCircle className="check-icon" /> Early Detection</li>
                                </ul>
                            </div>

                            <div className="highlight-divider"></div>

                            <div className="highlight-block">
                                <span className="highlight-badge dark">Protection</span>
                                <h3 className="highlight-title">Painless</h3>
                                <p className="highlight-desc">Gentle treatments for long-term health</p>
                                <ul className="highlight-list">
                                    <li><FaCheckCircle className="check-icon" /> Fluoride Application</li>
                                    <li><FaCheckCircle className="check-icon" /> Dental Sealants</li>
                                    <li><FaCheckCircle className="check-icon" /> No Discomfort</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="why-kosmix-bento">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Why Kosmix is Your Partner in Oral Health" />
                        <p1 className="text_first">
                            Our reputation as a trusted provider in HSR Layout is built on a foundation of technology and patient satisfaction:
                        </p1>
                    </div>

                    {/* Horizontal strip — top 3 */}
                    <div className="wkb-hstrip">
                        {reasons.slice(0, 3).map((reason, i) => (
                            <div className="wkb-hstrip-item" key={i} data-aos="fade-up" data-aos-delay={i * 120}>
                                <div className="wkb-hstrip-icon">{reason.icon}</div>
                                <div className="wkb-hstrip-line" />
                                <h3 className="wkb-hstrip-title">{reason.title}</h3>
                                <p className="wkb-hstrip-desc">{reason.description}</p>
                            </div>
                        ))}
                    </div>

                    {/* Vertical pair — bottom 3 */}
                    <div className="wkb-vgrid">
                        {reasons.slice(3).map((reason, i) => (
                            <div className="wkb-vgrid-item" key={i} data-aos="fade-up" data-aos-delay={i * 120}>
                                <div className="wkb-vgrid-left">
                                    <div className="wkb-vgrid-icon">{reason.icon}</div>
                                    <div className="wkb-vgrid-num">0{i + 4}</div>
                                </div>
                                <div className="wkb-vgrid-right">
                                    <h3>{reason.title}</h3>
                                    <p>{reason.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="cta-section" data-aos='zoom-in'>
                    <div className="cta-content">
                        <h2>
                            Maintain a Healthy Smile <span>Today!</span>
                        </h2>
                        <p>
                            Don't wait for pain to occur. Schedule your preventive dental checkup at Kosmix Dental Clinic and protect your oral health for life.
                        </p>
                        <div className="cta-buttons">
                            <Link to="/#appointment">
                                <button className="btn-primary">Book Preventive Visit</button>
                            </Link>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

const SectionTitle = ({ title }) => (
    <h2 className="section-title">{title}</h2>
);

export default PreventiveDentistry;